import { render, staticRenderFns } from "./TorrentTagsAndCategories.vue?vue&type=template&id=3e4a3976&scoped=true&"
import script from "./TorrentTagsAndCategories.vue?vue&type=script&lang=js&"
export * from "./TorrentTagsAndCategories.vue?vue&type=script&lang=js&"
import style0 from "./TorrentTagsAndCategories.vue?vue&type=style&index=0&id=3e4a3976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4a3976",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCol,VDivider,VListItem,VListItemContent,VListItemGroup,VListItemTitle,VRow,VSubheader})
